import { makeAutoObservable, runInAction } from 'mobx';

import { EResponseStatus } from '@enums';

import { Log } from '@utils';

import { Api, ICountersOptions } from '@api';

import { ICountersStore } from './types';

export class CountersStore {

	status: EResponseStatus = null;

	notifies = 0;

	dialogues = 0;

	games = 0;

	interval: ReturnType<typeof setInterval> = null;

	constructor() {
		makeAutoObservable(this, { interval: false });
	}

	get isWatchingNotify() {
		return Boolean(this.interval);
	}

	setCommonNotify = (value: number) => {
		this.notifies = value;
	};

	setDialoguesNotify = (value: number) => {
		/* Пока не используем нотифаи, но для прмера оставлю в комменте
		if (Boolean(value) && this.dialogues !== value ) {
			void NotificationsApi.show(
				`${translations.common('my')} - ${translations.common('dialoguesNotification')}`,
				{
					body: `You have ${value} new messages`,
					icon: getConfig().hosts.static + '/static/sharingImage.png',
					tag: 'dialoguesNotification',
				});
		}
		 */
		this.dialogues = value;
	};

	setGamesNotify = (value: number): void => {
		this.games = value;
	};

	watchNotify = async (args: ICountersOptions, period: number): Promise<void> => {
		return new Promise(() => {
			this.interval = setInterval(() => {
				if (this.status === EResponseStatus.OK) {
					void this.fetch(args);
				}
			}, period);
		});
	};

	stopWatchingNotify = () => {
		clearInterval(this.interval);
		this.interval = null;
	};

	async fetch(options: ICountersOptions): Promise<boolean> {
		this.status = EResponseStatus.PENDING;

		try {
			const { notify, dialogues, games } = await Api.counters.getCounters(options);

			runInAction(() => {
				this.status = EResponseStatus.OK;
				this.setCommonNotify(notify);
				this.setDialoguesNotify(dialogues);
				this.setGamesNotify(games);
			});

			return true;
		} catch (err) {
			Log.error(`Failed in getting COUNTERS in CountersStore; Error: ${err}`);
			runInAction(() => {
				this.status = EResponseStatus.ERROR;
			});

			return false;
		}
	}

	toJSON(): ICountersStore {
		return {
			notifies: this.notifies,
			dialogues: this.dialogues,
			games: this.games,
			status: this.status,
		};
	}

	fromJSON(data: ICountersStore): void {
		this.notifies = data?.notifies;
		this.dialogues = data?.dialogues;
		this.games = data?.games;
		this.status = data?.status;
	}

}
